import { createRoute } from '@tanstack/react-router'
import { Route as appLayoutRoute } from '../../layout'

export const Route = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/freight/dossiers/$fileId',
}).lazy(() => import('./$fileId.lazy').then((d) => d.Route))
